import React from 'react'
import { CmsBlock } from 'lib/shared/__DEPRECATED__/CmsBlock'
import { CMS_BLOCK } from 'app/sofia/resources/constants'
import { Container } from './components/Styled'

export const FooterLinks = () => {
  return (
    <Container>
      <CmsBlock
        id={CMS_BLOCK.FOOTER_QUICK_LINKS}
      >
        {({ isFailure, content }) => {
          if (isFailure) {
            if (!process.env.REACT_APP_ENABLE_CMS_BLOCK_SAMPLE_DATA) {
              return null
            }

            return (
              <SampleData />
            )
          }
          return (
            <div
              dangerouslySetInnerHTML={{
                __html: content
              }}
            />
          )
        }}
      </CmsBlock>
    </Container>
  )
}

const SampleData = () => {
  return (
    <>
      <h2>Let Us Help You.</h2>
      <ul className='footer__links'>
        <li><a href='/'>My Account</a></li>
        <li><a href='/'>My Orders</a></li>
        <li><a href='/'>Shipping Policy</a></li>
        <li><a href='/'>Returns & Swapouts</a></li>
        <li><a href='/'>Let’s Talk it Out</a></li>
      </ul>
      <ul className='footer__certs'>
        <li><img src='https://picsum.photos/60/60' alt='' /></li>
        <li><img src='https://picsum.photos/60/60' alt='' /></li>
        <li><img src='https://picsum.photos/60/60' alt='' /></li>
      </ul>
    </>
  )
}
